export { get, post, authGet, authPost, authPatch, setOnUnauthorized, ApiError, NetworkError, getApiBaseUrl } from './http_client.js';

export { AuthProvider } from './dto/auth.dto.js';
export { OfferEventType, OfferStore } from './dto/offers.dto.js';
export type { LoginRequest } from './dto/auth.dto.js';
export type { PlayerDto, UpdatePlayerRequest } from './dto/player.dto.js';
export type {
  CumulativeBoosterInventoryDto,
  BoosterPriceOfferDto,
  BoosterPricesEntryDto,
  BoostersPricesConfigDto,
  ConsumeBoosterRequest,
  ConsumeBoosterResponse,
  PurchaseBoosterRequest,
  PurchaseBoosterResponse,
} from './dto/cumulative_boosters.dto.js';
export type { OfferDto, OffersResponse, OfferProductDto } from './dto/offers.dto.js';

export { login, connectGoogle, connectFacebook, connectApple, disconnectProvider, deleteAccount, transferAccount } from './requests/auth.requests.js';
export { getPlayer, updatePlayer, getMyConfigs, getContentConfig } from './requests/player.requests.js';
export {
  getBoostersPricesConfig,
  consumeBooster,
  purchaseBooster,
} from './requests/cumulative_boosters.requests.js';
export { getOffers, getEntitlements, validateOfferPurchase, sendOfferEvent, reportOfferTriggerEvent } from './requests/offers.requests.js';

export { AuthSessionStore } from './auth_session.js';
export { PlayerSyncService } from './player_sync_service.js';
export { performLogin } from './perform_login.js';
